import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import { apiKeyTransformer } from './APITransformers';
import type { ApiKeyContent } from './Definitions/Types';

export class ApiKeyRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getApiKeys = (): Promise<ApiKeyContent[]> => {
    const requestData: IRequest = {
      endpoint: '',
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => apiKeyTransformer(response.data));
  };

  public generateNewApiKey = (apiKeyName: string): Promise<string> => {
    const requestData: IRequest = {
      endpoint: '',
      method: HttpMethod.POST,
      body: JSON.stringify({ key_name: apiKeyName }),
    };

    return this.requester.request(requestData).then((response) => response.data.api_key);
  };

  public revokeApiKey = (apiKeyPrefix: string): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `/${apiKeyPrefix}`,
      method: HttpMethod.DELETE,
    };

    return this.requester.request(requestData).then();
  };
}

export default ApiKeyRequester;
